import {formatCSV, parseCSV} from './csv.js'
import {isPresent} from './utils.js'

export function saveCSVFile(text, fileName) {
  if (window.THIS_IS_A_TEST_ENV) {
    saveCSVFile.last_call = [text, fileName]

    return
  }

  const file = new File([`${text}\n`], fileName, {
    type: 'text/plain',
  })

  const element = document.createElement('a')
  element.setAttribute('href', URL.createObjectURL(file))
  element.setAttribute('download', fileName)

  element.style.display = 'none'
  document.body.appendChild(element)

  element.click()

  document.body.removeChild(element)
}

export default function createCSVFile(headers, rows, fileName) {
  const isRowsOfObjects = !Array.isArray(rows[0])

  const orderedRows = isRowsOfObjects
    ? rows.map((row) =>
        headers.map((header) => (isPresent(row[header]) ? row[header] : '')),
      )
    : rows

  const csvText = formatCSV([headers, ...orderedRows])

  saveCSVFile(csvText, fileName || 'export.csv')
}

function isValidFile(file) {
  return (
    !file.type ||
    (file.type === 'application/vnd.ms-excel' && file.name.match(/\.csv$/i)) ||
    file.type.match(/^text/)
  )
}

export async function readCSVFile(files) {
  if (files.length > 1) {
    throw new Error('Only one file allowed at a time, buddy.')
  }

  const file = files[0]

  if (!isValidFile(file)) {
    throw new Error(
      `Rut roh. That file type is invalid. Only text files are accepted. You gave us: ${file.type}.`,
    )
  }

  var reader = new FileReader()

  // We need to hold off the next step a bit to let the browser render
  // the waiting graphics, because we could be dumping a large amount
  // of data into the DOM that will prevent other graphics from rendering
  setTimeout(() => {
    reader.readAsText(file)
  }, 50)

  const text = await new Promise((resolve) => {
    reader.onload = (event) => {
      resolve(event.target.result)
    }
  })

  try {
    return parseCSV(text)
  } catch (error) {
    throw new Error(
      `Something went wrong processing that file. ${error.message}`,
      {cause: error},
    )
  }
}
